import { render, staticRenderFns } from "./ModalTip.vue?vue&type=template&id=fe8a5162&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"
import style0 from "./ModalTip.vue?vue&type=style&index=0&id=fe8a5162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8a5162",
  null
  
)

export default component.exports